import { Component, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { SummaryTableEntry } from '../../context-discovery-services/models/summary-table-entry.model';
import { SiteService } from '../../context-discovery-services/services';
import { FeatureFlags } from '../../context-discovery-services/constants/feature-flags.const';
import { LaunchDarklyService } from '../../context-discovery-services/services/launch-darkly.service';
import { Equipment } from '../../context-discovery-services/models/equipment.model';
import { ContextDiscoveryEventBusService } from '../../context-discovery-services/services/context-discovery-event-bus.service';
import { Message } from '../../context-discovery-services/models/message.model';
import * as _ from 'lodash';
import { PublishStepper } from '../../context-discovery-services/models/publish-stepper.model';
import { SeverityType } from '../../context-discovery-services/constants/severity-type.const';


@Component({
  selector: 'adminapp-view-assets-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {

  private _modelId: any;
  private _isPublishInProgress: boolean;
  private _completeOnboardingStatus: PublishStepper[];
  _selectedAssetIri: string;
  @ViewChild('identifyAssetsModel') identifyAssetsModel: any;

  identifyAssetsMasterLoading: boolean = false;
  listOfAssetTypesAndEquipments = new Array<SummaryTableEntry>();
  _isAutomaticAnalyticsSetupFeatureEnabled: boolean;
  launchDarklySubscription: any;
  showAssetModel: boolean;
  isAssetSummaryLoading: boolean;
  canUserPublishAssetModel: boolean;

  @Output()
  layoutToWrapperEventEmitter: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  set modelId(idOfModel: string) {
    if (this._modelId === idOfModel) {
      return;
    }
    this._modelId = idOfModel;
    if (this._modelId) {
      this.getEquipments();
    }
  }

  @Input()
  set isPublishInProgress(isPublishInProgress: any) {
    if (this._isPublishInProgress !== isPublishInProgress) {
      this._isPublishInProgress = isPublishInProgress;
    }
  }

  @Input()
  set completeOnboardingStatus(completeOnboardingStatus: any) {
    if (JSON.stringify(this._completeOnboardingStatus) !== JSON.stringify(completeOnboardingStatus)) {
      this._completeOnboardingStatus = completeOnboardingStatus;
    }
  }

  @Input()
  set isAutomaticAnalyticsSetupFeatureEnabled(automaticAnalyticsSetupFeatureEnabled: boolean) {
    if (this._isAutomaticAnalyticsSetupFeatureEnabled !== automaticAnalyticsSetupFeatureEnabled) {
      this._isAutomaticAnalyticsSetupFeatureEnabled = automaticAnalyticsSetupFeatureEnabled;
    }
  }

  constructor(private siteService: SiteService, private ldService: LaunchDarklyService,
    private eventBusService: ContextDiscoveryEventBusService) {
    this.canUserPublishAssetModel = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.PUBLISH_ASSET_MODEL);
    this.launchDarklySubscription = this.ldService.flagChange.subscribe(_ => {
      this.canUserPublishAssetModel = this.ldService.getBooleanFeatureFlagValue(FeatureFlags.PUBLISH_ASSET_MODEL, true);
    });
    this.eventBusService.serverMessage$.subscribe((message: Message) => {
      const identifyAssetsToast: any = document.getElementById(message.severityType + 'IdentifyAssets');
      identifyAssetsToast.text = message.content;
      identifyAssetsToast.open();
    });
  }

  getEquipments() {
    this.isAssetSummaryLoading = true;
    this.siteService.listEquipments(this._modelId)
      .subscribe(this.getEquipmentSuccessCallBack.bind(this), this.getEquipmentFailureCallback.bind(this));
  }

  relayEventFromLayout(event) {
    this.layoutToWrapperEventEmitter.emit(event);
  }

  getEquipmentSuccessCallBack(equipments: Array<Equipment>) {
    const temp = [];
    _.each(equipments, function (equip) {
      const tableEntry = new SummaryTableEntry(equip.label, equip.confirmedAssetCount);
      tableEntry.objectMapped = equip;
      temp.push(tableEntry);
    });
    this.listOfAssetTypesAndEquipments = temp;
    this.isAssetSummaryLoading = false;
  }

  getEquipmentFailureCallback() {
    this.listOfAssetTypesAndEquipments = [];
    this.isAssetSummaryLoading = false;
    this.assetsOperationErrorCallback('Something went wrong. Please try again.');
  }

  showAssetModelView(event) {
    parent.postMessage({ 'showParentSideBar': false }, '*');  // hide the admin portal navigation bar
    this.showAssetModel = true;
    this._selectedAssetIri = event.assetIri;
  }

  closeAssetModelView() {
    this.showAssetModel = false;
    parent.postMessage({ 'showParentSideBar': true }, '*');  // show the admin portal navigation bar
    if (this._modelId) {
      this.getEquipments();
    }
  }

  handlePublishEvent(event) {
    this.showMasterLoadingAnimation();
    if (this._isAutomaticAnalyticsSetupFeatureEnabled) {
      const timezone = event.timezone;
      if (timezone) {
        this.siteService.publishWithAnalytics(this._modelId, true, timezone).subscribe(this.publishStartedSuccessCallback.bind(this),
          this.publishStartedFailureCallback.bind(this));
      } else {
        this.publishStartedFailureCallback();
      }
    } else {
      this.siteService.publish(this._modelId).subscribe(this.publishStartedSuccessCallback.bind(this),
        this.publishStartedFailureCallback.bind(this));
    }
  }

  publishStartedSuccessCallback() {
    this.stopMasterLoadingAnimation();
    this.layoutToWrapperEventEmitter.emit({
      eventType: 'PUBLISH'
    });
  }

  publishStartedFailureCallback() {
    this.stopMasterLoadingAnimation();
    this.assetsOperationErrorCallback('Unable to start publish');
  }

  showMasterLoadingAnimation() {
    this.identifyAssetsMasterLoading = true;
  }

  stopMasterLoadingAnimation() {
    this.identifyAssetsMasterLoading = false;
  }

  assetsOperationErrorCallback(message: string): any {
    this.layoutToWrapperEventEmitter.emit({
      eventType: 'SHOW_ERROR',
      message: new Message(message, SeverityType.CRITICAL)
    });
  }
}
